<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  name: 'app',
  components: {},
  mounted () {
    let _this = this
    console.log(this.$entity, 'this.$entity')
    window.TAL_UC.rankConfig({
      'client-id': '101100',
      'entity': _this.$entity
    })
  }
}
</script>
<style lang="less" scoped>
.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// module/passport/src/App.vue